<template>
	<div class="webContent flex">
		<div class="detail">
			<!-- <div class="tool df hao jcb">
				<div class="rule">公告</div>
				<div class="follow" :class="{ has: isFollow }" @click="follow">{{isFollow?'已关注':'关注问题'}}</div>
			</div> -->
			<div class="title">{{title}}</div>
			<div class="txt" v-html="txt">{{txt}}</div>
			<div class="end df hao">
				<div class="answerBtn" @click="toAnswer">写回答</div>
				<div class="flex"></div>
				<div class="like">{{likeCount}} 点赞</div>
				<div class="answer">{{answerCount}} 回答</div>
			</div>
			<div class="handle df hao">
				<div class="date">{{date}}</div>
				<div class="user">{{user}}</div>
				<div class="flex df war hao">
					<div class="topBtn" :class="{ none: type=='top'||type=='prize' }" @click="handle('top')">置顶</div>
					<div class="prizeBtn" :class="{ none: type=='top'||type=='prize' }" @click="handle('prize')">加精</div>
					<div class="removeBtn">删除</div>
				</div>
			</div>
			<div class="list">
				<div class="li" :class="{ 'li-blue': v.userpower=='teacher' }" v-for="(v,i) in list" :key="i">
					<div class="li-tool df hao">
						<div class="li-user">{{v.user}}</div>
						<div class="li-follow" :class="{ has: v.isFollow }" @click="followItem(i)">{{v.isFollow?'已关注':'关注'}}</div>
						<div class="flex"></div>
						<div class="li-collect" :class="{ has: v.isCollect }" @click="collectItem(i)">{{v.isCollect?'已收藏':'收藏'}}</div>
						<!-- <div class="li-addQuesition">追加提问</div> -->
					</div>
					<div class="li-txt" v-html="v.txt">{{v.txt}}</div>
					<div class="li-end df hao jcb">
						<div class="li-date">{{v.date}}</div>
						<div class="li-like">{{v.likeCount}}</div>
					</div>
					<div class="li-btn df war hao">
						<div class="li-archiveBtn" @click="openConfirm('archive','')">归档</div>
						<div class="li-removeBtn">删除</div>
					</div>
				</div>
			</div>
		</div>
	
		<!-- 收藏夹 -->
		<div class="collectBase" v-if="collectBase.has">
			<div class="collectBase-box">
				<div class="collectBase-top">
					<div class="collectBase-close" @click="closeCollectBase"></div>
					<span>已选择{{collectBase.choose.length}}个收藏夹</span>
					<div class="collectBase-add" @click="showCollectAddBase">新建收藏夹</div>
				</div>
				<div class="collectBase-list">
					<div class="collectBase-li" 
						:class="{ cur: collectBase.choose.indexOf(i)>=0 }" 
						v-for="(v,i) in collectBase.list" :key="i"
						@click="chooseCollectBase(i)">
						<div class="collectBase-title">{{v.title}}</div>
						<div class="collectBase-answer">{{v.answerCount}}个回答</div>
					</div>
				</div>
				<div class="collectBase-btn" @click="resCollectBase">确认</div>
			</div>
		</div>

		<!-- 添加收藏夹 -->
		<div class="collectAddBase df wao hao" v-if="collectAddBase.has">
			<div class="collectAddBase-box">
				<div class="collectAddBase-input df hao">
					<input type="text" puc class="flex" placeholder="输入收藏夹标题" v-model="collectAddBase.val" @input="checkInput" />
					<i>{{13-collectAddBase.val.length}}</i>
				</div>
				<div class="collectAddBase-end df war hao">
					<div class="collectAddBase-btn" @click="resCollectAddBase">确认</div>
					<div class="collectAddBase-btn" @click="closeCollectAddBase">取消</div>
				</div>
			</div>
		</div>

		<!-- 确认弹框 -->
		<div class="confirm df wao hao" v-if="confirm.has">
			<div class="confirm-box">
				<div class="confirm-txt" v-if="confirm.type=='archive'">确认将该回答进行<em>归档</em>操作吗？</div>
				<div class="confirm-end df war hao">
					<div class="confirm-btn" @click="resConfirm" v-if="confirm.type=='archive'">确认归档</div>
					<div class="confirm-btn" @click="closeConfirm">取消</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'admin_detail_page',
		data () {
			return {
				type: '', // [top 置顶] [prize 加精]
				title: '公告911板块规则',
				txt: '内容标准：个人原创，内容详细优秀，主题积极向上，图片清晰，排版合理，同一角度不应大量重复；<br>② 最低数量标准：文字200以上，图片15张以上；<br>③ vh备注：<br>a. 精华须以内容优先，内容需要有可读性，并非只达到数量要求就可以设精华；<br>b. 如内容拖沓、图片模糊、竖图横放、太多相似角度的图片、大多数文字从别处复制等，都不符合精华帖要求；<br>以下隐私内容予以删除：联系电话、家庭、学习及办公地址、QQ号、MSN等互联网聊天工具的账号、上网/注册、发布信息所使用的IP',
				likeCount: 12,
				answerCount: 4,
				user: '李玉雨（chshbs）',
				date: '2020-11-15',
				list: [
					{
						userpower: 'teacher', // 回答人员 [teacher 培训老师] [instructor 辅导员]
						user: '陆伟',
						txt: '4.3  论坛相关规定<br>（二）以下内容只删除图片<br>4.3.1  影响安全驾驶的行为照片（比如：安全带卡扣，未系安全带）<br>4.3.2  主帖文字部分不违规，仅删除个别违规图片。（图片涉及个人隐私、商业机密或准色情内容）<br>4.3.3  发帖人本人要求删除（私信）<br>4.4 涉及投诉或争吵的帖子，将统一移动到投诉建议区',
						date: '2020-11-22  12:24',
						likeCount: 4,
						isFollow: false,
						isCollect: false,
					},
					{
						userpower: 'instructor', // 回答人员 [teacher 培训老师] [instructor 辅导员]
						user: '张超未',
						txt: '补充1条：4.3  论坛相关规定（二）以下内容只删除图片<br>4.3.1  影响安全驾驶的行为照片（比如：安全带卡扣，未系安全带）<br>4.3.2  主帖文字部分不违规，仅删除个别违规图片。（图片涉及个人隐私、商业机密或准色情内容）<br>4.3.3  发帖人本人要求删除（私信）',
						date: '2020-11-22  12:24',
						likeCount: 4,
						isFollow: false,
						isCollect: false,
					},
				],
				isFollow: false,
				collectBase: {
					index: null,
					has: false,
					choose: [],
					list: [],
				},
				collectAddBase: {
					has: false,
					val: '',
				},
				confirm: {
					has: false,
					type: '',
					txt: '',
				},
			}
		},
		methods: {
			follow(){
				this.isFollow = !this.isFollow;
			},
			handle(type){
				alert('操作成功');
				this.type = type;
			},
			followItem(index){
				this.list[index].isFollow = !this.list[index].isFollow;
			},
			collectItem(index){
				if(this.list[index].isCollect){
					this.list[index].isCollect = false;
				}else{
					this.collectBase = {
						index: index,
						has: true,
						choose: [],
						list: [
							{ title: '911相关', answerCount: 2 },
							{ title: '718相关', answerCount: 2 },
							{ title: 'Taycan相关', answerCount: 2 },
						],
					};
				}
			},
			closeCollectBase(){
				this.collectBase.has = false;
			},
			resCollectBase(){
				this.collectBase.has = false;
				this.list[this.collectBase.index].isCollect = true;
			},
			showCollectAddBase(){
				this.collectAddBase = {
					has: true,
					val: '',
				}
			},
			closeCollectAddBase(){
				this.collectAddBase.has = false;
			},
			resCollectAddBase(){
				this.collectAddBase.has = false;
			},
			chooseCollectBase(index){
				// if(this.collectBase.choose.indexOf(index)>=0){
				// 	this.collectBase.choose.splice(this.collectBase.choose.indexOf(index),1);
				// }else{
				// 	this.collectBase.choose.push(index);
				// }
				if(this.collectBase.choose[0]==index){
					this.collectBase.choose = [];
				}else{
					this.collectBase.choose = [index];
				}
			},
			checkInput(){
				if(this.collectAddBase.val.length>13){
					this.collectAddBase.val = this.collectAddBase.val.substring(0,13);
				}
			},
			openConfirm(type,txt){
				this.confirm = {
					has: true,
					type: type,
					txt: txt,
				};
			},
			closeConfirm(){
				this.confirm.has = false;
			},
			resConfirm(){
				this.confirm.has = false;
			},
			toAnswer(){
				this.$router.replace('/admin/release');
			},
		},
	}
</script>

<style scoped>
	@import './detail'
</style>



// WEBPACK FOOTER //
// src/app/pages/admin/detail/detail.vue